import React, { useState } from "react";
import { useEffect } from "react";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import { Link } from 'react-router-dom'
import { ChevronRight } from "@mui/icons-material";
function Header() {
    const [collapse, setCollapsed] = useState(false);
    const [slideLeft, setSlideLeft] = useState(true);
    useEffect(() => {
        // add active class to header on mobile devices
        const navItems = document.querySelector(".header .header-bottom .main-nav");
        if (navItems) {
            if (collapse === true) {
                navItems.classList.remove("slide-left");
                return navItems.classList.add("collapsed");
            }
            else if (collapse === false) {
                // return navItems.classList.remove("navbar-toggle hide");

                navItems.classList.add("slide-left");
                return navItems.classList.remove("collapsed");
            }

        }

    }, [collapse]);
    //
    useEffect(() => {
        const header = document.querySelector("[data-header]");
        window.addEventListener("scroll", function () {
            window.scrollY >= 400 ? header.classList.add("active")
                : header.classList.remove("active");
        });
        return (() => {
            window.removeEventListener("scroll", function () {
                window.scrollY >= 400 ? header.classList.add("active")
                    : header.classList.remove("active");
            });
        });
    }, []);
    return (

        <header className="header" data-header>
            <div className="overlay" data-overlay></div>
            <div className="header-top">
                <div className="container">
                    <ul className="header-top-list">
                        <li>
                            <Link to="mailto:info@deepblue.com" className="header-top-link">
                                <MailOutlineIcon className="icon" />
                                <span>info@deepblue.com</span>
                            </Link>
                        </li>
                        <li>
                            <a href="tel:+233200286602" className="header-top-link">
                                <SupportAgentOutlinedIcon className="icon" />

                                <span>+233 20 028 6602</span>
                            </a>
                        </li>
                    </ul>

                    <div className="wrapper">
                        <button className="header-top-btn">Try For Free
                            <span><ChevronRight /></span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="header-bottom">
                <div className="container">
                    <div className="main-nav">
                        <Link to="/" className="logo nav-logo"
                        >
                            <h1 className="h1">
                                DEEP
                                <span>BLUE</span>
                            </h1>
                        </Link>
                        <nav className="navbar" data-navbar>
                            <div className="navbar-bottom ">
                                <ul className="navbar-list">
                                    <li>
                                        <Link to="#" className="navbar-link dropdown-btn" data-nav-link >
                                            Features
                                            <div className="dropdown-content">
                                                <ul>
                                                    <li>
                                                        <Link to={"/auth"}>  Dashboard</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={"/automations"} >Automations</Link>
                                                    </li>

                                                </ul>
                                            </div>
                                        </Link>
                                    </li>


                                    <li>
                                        <Link to="/integrations" className="navbar-link" data-nav-link>
                                            Integrations
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/contact-sales" className="navbar-link" data-nav-link>
                                            Contact Sales
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/about-us" className="navbar-link" data-nav-link>
                                            About Us
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" className="navbar-link dropdown-btn" data-nav-link >
                                            Resources
                                            <div className="dropdown-content">
                                                <ul>
                                                    <li>
                                                        <Link to={"/resources/blog"}>  CRM Blog</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={"/resources/terms-and-conditions"} >Terms & Conditions</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={"/resources/faqs"}>Deepblue Faqs</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={"/contact-sales"}>24/7 Support</Link>
                                                    </li>

                                                </ul>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>

                    <div className="header-bottom-actions">
                        <button className="nav-actions-btn" aria-label="Search">

                            <SearchOutlinedIcon className="icon" />
                            <span>Search</span>
                        </button>

                        <button className="nav-actions-btn" aria-label="Profile">
                            <a href="/auth">< AccountCircleOutlinedIcon className="icon" />
                                <span>Profile</span></a>
                        </button>
                        <button
                            className="nav-actions-btn navbar-toggler"
                            data-nav-open-btn
                            aria-label="Open Menu"
                            data-toggle="collapse"
                            onClick={() => {
                                setCollapsed(!collapse);
                                setSlideLeft(!slideLeft);
                            }}
                        >
                            {collapse ? <>

                                <span className="icon-bar x"></span>
                                <span className="icon-bar x"></span>
                                <span className="icon-bar x"></span>
                                <span>Menu</span>
                            </> : <>

                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span>Menu</span>
                            </>}
                        </button>
                    </div>
                </div>
            </div>
        </header >
    );
}
export default Header;
